export default __webpack_public_path__ + "static/media/wetu.b3f47d74.svg";